import { render, staticRenderFns } from "./Stub.vue?vue&type=template&id=cd05da8e&scoped=true&"
import script from "./Stub.vue?vue&type=script&lang=js&"
export * from "./Stub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd05da8e",
  null
  
)

export default component.exports